/* HYPERCUB (sleepwhale clone): scroll reveals, hero review switcher, focus gauge, PDP gallery + one-time pack cards + add to cart, ingredients slider, importance toggle. */
(function(){
  function $$(r, s){ return [].slice.call((r || document).querySelectorAll(s)); }

  function seen(els, fn, margin){
    if (!('IntersectionObserver' in window)){ els.forEach(fn); return; }
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ fn(e.target); io.unobserve(e.target); } }); }, { rootMargin: margin || '0px 0px -8% 0px' });
    els.forEach(function(e){ io.observe(e); });
  }

  function reveal(){
    seen($$(document, '.hc [data-rv]:not(.in)'), function(e){ e.classList.add('in'); });
    setTimeout(function(){ $$(document, '.hc [data-rv]:not(.in)').forEach(function(e){ if (e.getBoundingClientRect().top < window.innerHeight) e.classList.add('in'); }); }, 900);
  }

  function heroReviews(){
    $$(document, '[data-hc-rs]').forEach(function(w){
      var q = w.querySelector('.hc-rs-q'), n = w.querySelector('.hc-rs-n span'), avs = $$(w, '.hc-rs-av'), i = 0, t;
      function pick(k){ i = k; avs.forEach(function(a, j){ a.classList.toggle('on', j === k); }); q.textContent = '"' + avs[k].getAttribute('data-q') + '"'; n.textContent = avs[k].getAttribute('data-n'); }
      avs.forEach(function(a, j){ a.addEventListener('click', function(){ clearInterval(t); pick(j); }); });
      t = setInterval(function(){ pick((i + 1) % avs.length); }, 4500);
    });
  }

  function gauges(){
    $$(document, '.hc-card [data-hc-count]').forEach(function(n){ n.textContent = '0'; });
    seen($$(document, '[data-hc-gauge]'), function(g){
      var bar = g.querySelector('.hc-gauge-bar'), card = g.closest('.hc-card') || g, num = card.querySelector('[data-hc-count]');
      if (!num) return;
      var target = parseInt(num.getAttribute('data-hc-count'), 10) || 100;
      bar.style.strokeDashoffset = String(440 - 440 * target / 100);
      var t0 = null;
      function step(ts){ if (!t0) t0 = ts; var p = Math.min(1, (ts - t0) / 2200); num.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    }, '0px 0px -15% 0px');
  }

  function money(c){ return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(c) : '$' + (c / 100).toFixed(2); }

  function pdp(R){
    if (R.__hc) return; R.__hc = 1;
    // gallery
    var slides = $$(R, '.hc-gal-s'), thumbs = $$(R, '.hc-gal-th button'), cnt = R.querySelector('.hc-gal-c b'), gi = 0;
    var strip = R.querySelector('.hc-gal-th'), timer = null;
    // auto-advance every 10s; any shopper interaction restarts the clock
    function arm(){ clearInterval(timer); if (slides.length > 1) timer = setInterval(function(){ if (!document.hidden) show(gi + 1, true); }, 10000); }
    function show(k, auto){ if (!slides.length) return; gi = (k + slides.length) % slides.length; slides.forEach(function(s, j){ s.classList.toggle('on', j === gi); }); thumbs.forEach(function(b){ b.classList.toggle('on', parseInt(b.getAttribute('data-i'), 10) === gi); }); if (cnt) cnt.textContent = gi + 1;
      var t = thumbs[gi]; if (strip && t){ var l = t.offsetLeft, r = l + t.offsetWidth, x = strip.scrollLeft; if (l < x) strip.scrollTo({ left: l, behavior: 'smooth' }); else if (r > x + strip.clientWidth) strip.scrollTo({ left: r - strip.clientWidth, behavior: 'smooth' }); }
      if (!auto) arm(); }
    arm();
    thumbs.forEach(function(b){ b.addEventListener('click', function(){ show(parseInt(b.getAttribute('data-i'), 10)); }); });
    $$(R, '.hc-gal-b').forEach(function(b){ b.addEventListener('click', function(){ show(gi + parseInt(b.getAttribute('data-d'), 10)); }); });
    var gm = R.querySelector('.hc-gal-main'), sx = null;
    if (gm){ gm.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; }, { passive: true }); gm.addEventListener('touchend', function(e){ if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(gi + (dx < 0 ? 1 : -1)); sx = null; }); }

    // pack cards (one-time only)
    var opts = $$(R, '.hc-opt'), atc = R.querySelector('.hc-atc'), err = R.querySelector('.hc-err'), qi = R.querySelector('.hc-qty input');
    var label = atc ? atc.textContent : 'Add to cart';
    function cur(){ return R.querySelector('.hc-opt.on') || opts[0]; }
    function q(){ return Math.max(1, parseInt(qi && qi.value, 10) || 1); }
    // purchase type (subscribe & save / one-time)
    var PT = R.querySelector('[data-hc-ptype]'), pcards = PT ? $$(PT, '.hc-pt') : [];
    function isSub(){ return !!(PT && PT.querySelector('.hc-pt-sub.on')); }
    function plan(){ var f = PT && PT.querySelector('[data-pt-freq]'); return f ? parseInt(f.value, 10) : null; }
    function subOf(c){ var pct = PT ? parseFloat(PT.getAttribute('data-pct')) || 0 : 0; return Math.round(c * (100 - pct) / 100); }
    function priceOf(o){ var c = parseInt(o.getAttribute('data-p'), 10); return isSub() ? subOf(c) : c; }
    function packs(){
      opts.forEach(function(o){
        var p = priceOf(o), full = parseInt(o.getAttribute('data-full'), 10) || p, mints = parseInt(o.getAttribute('data-mints'), 10) || 1;
        var b = o.querySelector('[data-price]'), e = o.querySelector('[data-each]'), sv = o.querySelector('[data-save]');
        if (b) b.textContent = money(p);
        if (e) e.textContent = money(Math.round(p / mints));
        if (sv) sv.textContent = money(full - p).replace(/\.00$/, '');
      });
      if (PT){ var o = cur(), c = o ? parseInt(o.getAttribute('data-p'), 10) : 0;
        var f = PT.querySelector('[data-pt-full]'), s = PT.querySelector('[data-pt-sub]'), n = PT.querySelector('[data-pt-one]');
        if (f) f.textContent = money(c); if (s) s.textContent = money(subOf(c)); if (n) n.textContent = money(c); }
    }
    pcards.forEach(function(c){
      function pick(){ pcards.forEach(function(x){ x.classList.toggle('on', x === c); x.setAttribute('aria-checked', x === c ? 'true' : 'false'); }); paint(); }
      c.addEventListener('click', function(e){ if (e.target.closest('select')) return; pick(); });
      c.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); pick(); } });
    });
    function paint(){ packs(); var o = cur(); if (!o || !atc) return; var p = priceOf(o) * q(); atc.textContent = label + ' · ' + money(p); }
    function tier(){ var o = cur(); return o ? parseInt(o.getAttribute('data-tier'), 10) || 1 : 1; }
    function gifts(){ var t = tier(); $$(R, '.hc-gift').forEach(function(g){ g.classList.toggle('locked', t < (parseInt(g.getAttribute('data-unlock'), 10) || 1)); }); }
    opts.forEach(function(o){ o.addEventListener('click', function(){ opts.forEach(function(x){ x.classList.toggle('on', x === o); }); var r = o.querySelector('input'); if (r) r.checked = true; if (err) err.hidden = true; paint(); gifts(); }); });
    gifts();
    var sd = R.querySelector('[data-hc-shipdate]');
    if (sd){ var d = new Date(); d.setDate(d.getDate() + 1); while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1); sd.textContent = d.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' }); }
    $$(R, '.hc-qty button').forEach(function(b){ b.addEventListener('click', function(){ qi.value = Math.max(1, q() + parseInt(b.getAttribute('data-q'), 10)); paint(); }); });
    if (qi) qi.addEventListener('change', paint);
    paint();

    function fail(m){ atc.disabled = false; paint(); if (err){ err.textContent = m || 'Could not add to cart. Please try again.'; err.hidden = false; } }
    if (atc) atc.addEventListener('click', function(){
      var o = cur(); if (!o) return;
      atc.disabled = true; atc.textContent = 'Adding…';
      var drawer = document.querySelector('cart-drawer'), body = { items: [{ id: parseInt(o.getAttribute('data-id'), 10), quantity: q() }] };
      if (isSub() && plan()) body.items[0].selling_plan = plan();
      // free gifts ride along with the qualifying offer (one each, regardless of quantity)
      [['data-g2', 'data-g2t'], ['data-g3', 'data-g3t']].forEach(function(g){ var id = parseInt(R.getAttribute(g[0]), 10); if (id && tier() >= (parseInt(R.getAttribute(g[1]), 10) || 99)) body.items.push({ id: id, quantity: 1 }); });
      if (drawer && typeof drawer.renderContents === 'function'){ body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
      // shipping protection is on by default; the drawer toggle opts out and we remember that
      var sp = parseInt(R.getAttribute('data-sp'), 10), spOff = false;
      try { spOff = localStorage.getItem('hcSpOff') === '1'; } catch(e){}
      var pre = (sp && !spOff) ? fetch('/cart.js', { credentials: 'same-origin' }).then(function(r){ return r.json(); }).then(function(c){
        if (!c.items.some(function(it){ return it.id === sp; })) body.items.push({ id: sp, quantity: 1 });
      }).catch(function(){}) : Promise.resolve();
      pre.then(function(){ return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
        .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
        .then(function(res){
          atc.disabled = false; paint();
          if (drawer && res && res.sections && res.sections['cart-drawer']){
            try { drawer.classList.remove('is-empty'); drawer.renderContents({ id: body.items[0].id, sections: res.sections }); return; } catch(e){}
          }
          window.location.href = '/cart';
        }); }).catch(function(e){ fail(e && (e.description || e.message)); });
    });

    var sticky = R.parentNode.querySelector('.hc-sticky');
    if (sticky && atc){
      var st = function(){ sticky.classList.toggle('on', atc.getBoundingClientRect().bottom < 0); };
      window.addEventListener('scroll', st, { passive: true }); st();
    }
  }

  // remember when a shopper switches shipping protection off (or back on) in the cart drawer
  function spToggle(){
    document.addEventListener('click', function(e){
      var sw = e.target.closest && e.target.closest('.gb-shipping-protection-button label.switch');
      if (!sw || e.target.tagName === 'INPUT') return;
      try { if (sw.classList.contains('checked')) localStorage.setItem('hcSpOff', '1'); else localStorage.removeItem('hcSpOff'); } catch(err){}
    }, true);
  }

  function ingredients(){
    $$(document, '[data-hc-ing]').forEach(function(w){
      if (w.__hc) return; w.__hc = 1;
      var tabs = $$(w, '.hc-ing-tabs button'), cards = $$(w, '.hc-ing-c'), i = 0;
      function go(k){ if (!cards.length) return; i = (k + cards.length) % cards.length; tabs.forEach(function(t, j){ t.classList.toggle('on', j === i); }); cards.forEach(function(c, j){ c.classList.toggle('on', j === i); }); if (tabs[i] && tabs[i].scrollIntoView && window.innerWidth < 750) tabs[i].parentNode.scrollTo({ left: tabs[i].offsetLeft - 16, behavior: 'smooth' }); }
      tabs.forEach(function(t, j){ t.addEventListener('click', function(){ go(j); }); });
      $$(w, '.hc-ing-nav button').forEach(function(b){ b.addEventListener('click', function(){ go(i + parseInt(b.getAttribute('data-d'), 10)); }); });
    });
  }

  function importance(){
    $$(document, '[data-hc-imp]').forEach(function(w){
      if (w.__hc) return; w.__hc = 1;
      var bs = $$(w, '.hc-imp-tg button'), vs = $$(w, '.hc-imp-v');
      bs.forEach(function(b){ b.addEventListener('click', function(){ var k = b.getAttribute('data-k'); bs.forEach(function(x){ x.classList.toggle('on', x === b); }); vs.forEach(function(v){ v.classList.toggle('on', v.getAttribute('data-k') === k); }); }); });
    });
  }

  document.addEventListener('click', function(e){
    var t = e.target && e.target.closest ? e.target.closest('[data-hc-top]') : null;
    if (!t) return;
    var top = document.getElementById('hc-top');
    window.scrollTo({ top: top ? top.getBoundingClientRect().top + window.scrollY - 80 : 0, behavior: 'smooth' });
  });

  // landing-page quiz: one question per screen, auto-advance on single answers, loader, then redirect
  function quiz(){
    $$(document, '[data-hc-quiz]').forEach(function(R){
      if (R.__q) return; R.__q = 1;
      var steps = $$(R, '[data-q-step]'), load = R.querySelector('[data-q-load]'), bar = R.querySelector('[data-q-bar]'), i = 0;
      var msgs = (R.getAttribute('data-msgs') || '').split('|').filter(Boolean);
      function show(n){ steps.forEach(function(s, k){ s.classList.toggle('on', k === n); }); bar.style.width = bar.style.minWidth = Math.round(n / steps.length * 100) + '%'; window.scrollTo(0, 0); }
      function finish(){
        steps.forEach(function(s){ s.classList.remove('on'); }); load.classList.add('on'); bar.style.width = bar.style.minWidth = '100%';
        var p = 0, pct = R.querySelector('[data-q-pct]'), msg = R.querySelector('[data-q-msg]');
        var t = setInterval(function(){
          p += 2; pct.textContent = p + '%';
          msg.textContent = msgs[Math.min(msgs.length - 1, Math.floor(p / (100 / Math.max(1, msgs.length))))] || '';
          if (p >= 100){ clearInterval(t); var res = R.querySelector('[data-q-res]'); if (!res) { window.location.href = R.getAttribute('data-go') || '/'; return; } var ag = (R.__age || '').split('(')[0].replace(/years? old/i, 'year old').trim(); $$(res, '[data-q-age]').forEach(function(e){ e.textContent = ag || 'child'; }); load.classList.remove('on'); res.classList.add('on'); window.scrollTo(0, 0); }
        }, 60);
      }
      function next(){ i++; if (i < steps.length) show(i); else finish(); }
      steps.forEach(function(s){
        var multi = s.querySelector('.hc-quiz-o.multi'), nb = s.querySelector('.hc-quiz-next');
        $$(s, '.hc-quiz-opt').forEach(function(o){
          o.addEventListener('click', function(){
            if (multi){ o.classList.toggle('on'); nb.disabled = !s.querySelector('.hc-quiz-opt.on'); }
            else { o.classList.add('on'); if (s === steps[0]) R.__age = o.textContent; setTimeout(next, 250); }
          });
        });
        if (nb) nb.addEventListener('click', next);
      });
      if (steps.length) show(0);
    });
  }

  // reviews: show the first N, reveal N more per click
  function reviews(){
    $$(document, '[data-hc-revs]').forEach(function(L){
      if (L.__r) return; L.__r = 1;
      var per = parseInt(L.getAttribute('data-hc-revs'), 10) || 6, items = $$(L, '.hc-rev-i'), shown = per;
      var btn = L.parentNode.querySelector('[data-hc-revmore]');
      function paint(){ items.forEach(function(it, k){ it.classList.toggle('hc-rev-hide', k >= shown); }); if (btn) btn.hidden = shown >= items.length; }
      if (btn) btn.addEventListener('click', function(){ shown += per; paint(); });
      paint();
    });
  }

  // advertorial carousel: arrows + dots over a scroll-snap track
  function adCar(){
    $$(document, '[data-hc-car]').forEach(function(C){
      if (C.__c) return; C.__c = 1;
      var tr = C.querySelector('[data-car-track]'), dots = $$(C, '[data-car-dots] i');
      function idx(){ return Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth)); }
      function paint(){ var k = idx(); dots.forEach(function(d, j){ d.classList.toggle('on', j === k); }); }
      $$(C, '[data-car]').forEach(function(b){
        b.addEventListener('click', function(){ var k = idx() + parseInt(b.getAttribute('data-car'), 10); k = (k + dots.length) % dots.length; tr.scrollTo({ left: k * tr.clientWidth, behavior: 'smooth' }); });
      });
      tr.addEventListener('scroll', paint, { passive: true }); paint();
    });
  }

  var spBound = 0;
  function boot(){ if (!spBound){ spBound = 1; spToggle(); } reveal(); heroReviews(); gauges(); $$(document, '[data-hc-pdp]').forEach(pdp); ingredients(); importance(); quiz(); reviews(); adCar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
